import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";

export const Bubble = ({ from = "bot", time, children, bare = false, testId }) => {
  const me = from === "me";
  return (
    <motion.div
      data-testid={testId}
      className={`flex ${me ? "justify-end" : "justify-start"}`}
      initial={{ opacity: 0, y: 14, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: "spring", stiffness: 380, damping: 28 }}
      style={{ transformOrigin: me ? "bottom right" : "bottom left" }}
    >
      <div className={bare ? "lz-bare" : me ? "lz-bubble lz-me" : "lz-bubble lz-bot"}>
        {children}
        <span className="lz-time">
          {time}
          {me && <CheckCheck size={14} className="text-[#7FD8FF]" />}
        </span>
      </div>
    </motion.div>
  );
};

export const Typing = () => (
  <motion.div data-testid="typing-indicator" className="flex justify-start"
    initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
    <div className="lz-bubble lz-bot lz-typing">
      <span /><span /><span />
    </div>
  </motion.div>
);
